import axios from 'axios'
import API from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/opciones-menu-personalizados`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  actualizar(opcion) {
    return apiClient.post(`${opcion.id}`, opcion)
  },

  eliminar(idOpcion) {
    return apiClient.delete(`${idOpcion}`)
  },

  guardar(opcion) {
    return apiClient.post('', opcion)
  },

  opcionJSON(idOpcion) {
    return apiClient.get(`${idOpcion}.json`)
  },

  opcionesJSON(params) {
    params = params || {}
    return apiClient.get(`${API}/opciones-menu-personalizados.json`, { params: params })
  }
}